module.exports = __webpack_public_path__ + "static/img/store_19.6b81bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/store_19.png
// module id = 2HCv
// module chunks = 1